import { log, supabase } from ".";
import { client } from "./supabase";

export const getEdificios = async ({ pais }) => {
  try {
    const data = await supabase.select("edificios", {
      // Guard #1 (server): PostgREST filtra eliminada=false. Doble guard con el belt de abajo (regla 10.114).
      filters: { pais, eliminada: false },
      orderBy: [
        { column: "estado", ascending: true },
        { column: "pantallas", ascending: false },
      ],
    });

    if (data?.length === 0) {
      // Removed toast.error to prevent UI notification
      return []; // Return empty array instead of throwing error
    }

    // Guard #2 (cliente): belt-and-suspenders coherente con getEdificiosOperativos.js / getEdificiosListadoPublico.js.
    return (data ?? []).filter((edificio) => !edificio.eliminada);
  } catch (error) {
    log.error("getEdificios", error);
    throw error; // Throw only for other errors (e.g., network issues)
  }
};

// Soft-delete de un edificio (nunca DELETE físico: hay 5 FKs sin ON DELETE CASCADE —
// pantallas, plan_pagos_edificios, comision_snapshot_edificio, edificios_parque_historial,
// reportes_fotograficos). Calca el patrón de eliminarActivo (src/utils/activos.js).
export const eliminarEdificio = async (id) => {
  const { error } = await client
    .from("edificios")
    .update({ eliminada: true, updated_at: new Date().toISOString() })
    .eq("id", id);
  if (error) throw error; // Propagar el error — prohibido el fallo silencioso (regla 10.177).
};
